import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { resolveImage } from "@/lib/siteDefaults";
import VeteranBadge from "@/components/VeteranBadge";

export default function About() {
  const { site } = useSite();
  const a = site.about;

  return (
    <div className="pt-24 md:pt-32 pb-24 md:pb-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <VeteranBadge className="mb-6" />
        <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-6">{a.overline}</p>
        <h1 className="font-serif text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-light tracking-tighter text-[#1A1C1A] max-w-5xl leading-[0.9]">
          {a.heading_line_1} <em className="italic text-stone-600">{a.heading_em}</em>{a.heading_line_3}
        </h1>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <img src={resolveImage(a.section_1.image)} alt="Section 1" className="rounded-2xl w-full aspect-[4/5] object-cover" />
          </div>
          <div className="md:col-span-6 md:pt-16">
            <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-4">{a.section_1.overline}</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light tracking-tight text-[#1A1C1A] mb-6">
              {a.section_1.title_line_1} <em className="italic text-stone-600">{a.section_1.title_em}</em>{a.section_1.title_line_3}
            </h2>
            <p className="text-lg leading-relaxed text-stone-700 font-light">
              {a.section_1.body}
            </p>
          </div>
        </div>

        <div className="mt-20 md:mt-32 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-6 order-2 md:order-1">
            <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-4">{a.section_2.overline}</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light tracking-tight text-[#1A1C1A] mb-6">
              {a.section_2.title_line_1} <em className="italic text-stone-600">{a.section_2.title_em}</em>{a.section_2.title_line_3}
            </h2>
            <p className="text-lg leading-relaxed text-stone-700 font-light">
              {a.section_2.body}
            </p>
            {a.section_2.quote_text && (
              <blockquote className="mt-10 border-l-2 border-stone-400 pl-6 font-serif italic text-2xl text-stone-600">
                {a.section_2.quote_text}
                {a.section_2.quote_source && (
                  <footer className="text-sm mt-3 not-italic text-stone-500 font-sans tracking-wide">{a.section_2.quote_source}</footer>
                )}
              </blockquote>
            )}
          </div>
          <div className="md:col-span-6 order-1 md:order-2">
            <img src={resolveImage(a.section_2.image)} alt="Section 2" className="rounded-2xl w-full aspect-[4/5] object-cover" />
          </div>
        </div>

        <div className="mt-24 md:mt-40 bg-[#F4F1EA] rounded-3xl p-10 md:p-20 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-6">{a.cta.overline}</p>
          <h2 className="font-serif text-5xl md:text-6xl font-light tracking-tighter text-[#1A1C1A] mb-6">
            {a.cta.title_line_1} <em className="italic text-stone-600">{a.cta.title_em}</em>{a.cta.title_line_3}
          </h2>
          <p className="max-w-2xl mx-auto text-lg text-stone-600 font-light">
            {a.cta.body}
          </p>
          <Link
            to="/shop"
            className="mt-10 inline-block bg-[#1A1C1A] text-[#F9F9F6] hover:bg-[#3C3E3C] px-10 py-4 rounded-full font-sans text-sm tracking-wider uppercase"
          >
            {a.cta.cta_label}
          </Link>
        </div>
      </div>
    </div>
  );
}
